import { Type } from "@sinclair/typebox";
import { IdLike, NullableIdLike } from "../../../utils/typeboxTypes";
export const User = Type.Object({
    /**
     * The Deskpro unique ID of the user. */
    id: IdLike,
    /**
     * The external unique ID of the user.
     */
    external_id: Type.Optional(NullableIdLike),
    /**
     * Users name.
     */
    name: Type.Optional(Type.String()),
    first_name: Type.Optional(Type.String()),
    last_name: Type.Optional(Type.String()),
    /**
     * Email address of the recipient.
     */
    email: Type.Optional(Type.String()),
}, {
    title: "User",
});
export const UserConfirmationMethodSchema = Type.Union([
    Type.Literal("jwt"),
    Type.Literal("email_code"),
]);
export const UserConfirmationSchema = Type.Object({
    isConfirmed: Type.Boolean(),
    method: Type.Optional(UserConfirmationMethodSchema),
    confirmedAt: Type.Optional(Type.String()),
});
export const PersonSessionContextSchema = Type.Object({
    id: Type.Optional(IdLike),
    userGroups: Type.Optional(Type.Array(IdLike)),
    identity: Type.Optional(UserConfirmationSchema),
    isLoggedIn: Type.Optional(Type.Boolean()),
});
